import { stateGetters, stateSetters, watchGetterAndPersist } from '@/utils/store/store-utils'
import bus from '@/plugins/eventbus'
import getBrowser from '@/plugins/browser-polyfill'

const defaultState = {
  newTabOverride: false,
}

export default {
  name: 'extension',
  namespaced: true,
  state: () => defaultState,
  getters: {
    ...stateGetters(defaultState),
  },
  mutations: {
    ...stateSetters(defaultState),
  },
  actions: {
    async toggleNewTabOverride({ commit, dispatch }, enabled) {
      commit('setNewTabOverride', enabled)

      if (BUILD_TARGET === 'extension') {
        await dispatch('applyNewTabOverride', enabled)
      }
      return enabled
    },
    async applyNewTabOverride(_, enabled) {
      if (BUILD_TARGET === 'extension') {
        const browser = await getBrowser()

        await browser.runtime.sendMessage({
          event: 'background:toggle-new-table-override',
          data: {
            enabled,
          },
        })
      }
    },
  },
}

bus.$once('app:created', async app => {
  if (BUILD_TARGET === 'extension') {
    const browser = await getBrowser()
    const result = await browser.storage.local.get('newTabOverride')
    const newTabOverride = result?.newTabOverride ?? true

    app.config.globalProperties.$store.dispatch('extension/toggleNewTabOverride', newTabOverride)

    watchGetterAndPersist(app.config.globalProperties.$store, 'extension/newTabOverride', 'newTabOverride')
  }
})
